"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _exchangeUiComponents = require("@mulesoft/exchange-ui-components");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = {
  "draggable": "DraggableTree__draggable__2vhb5",
  "sidebar-item": "DraggableTree__sidebar-item__2Hl6M",
  "sidebarItem": "DraggableTree__sidebar-item__2Hl6M",
  "dragged-element": "DraggableTree__dragged-element__qRP8R",
  "draggedElement": "DraggableTree__dragged-element__qRP8R"
}; 
require('./DraggableTree.css');
var reOrder = function reOrder(list, startIndex, endIndex) {
  var result = (0, _toConsumableArray2.default)(list);
  var _result$splice = result.splice(startIndex, 1),
    _result$splice2 = (0, _slicedToArray2.default)(_result$splice, 1),
    removed = _result$splice2[0];
  result.splice(endIndex, 0, removed);
  return result;
};
var DraggableTree = /*#__PURE__*/function (_React$Component) {
  function DraggableTree() {
    var _this;
    (0, _classCallCheck2.default)(this, DraggableTree);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DraggableTree, [].concat(args));
    (0, _defineProperty2.default)(_this, "onDragEnd", function (result) {
      var isSamePosition = result.destination && result.source.index === result.destination.index;
      if (!result.destination || isSamePosition) {
        return;
      }
      var items = reOrder(
      // eslint-disable-next-line react/destructuring-assignment
      _this.props.items, result.source.index, result.destination.index);

      // eslint-disable-next-line react/destructuring-assignment
      _this.props.onOrderItems(items);
    });
    return _this;
  }
  (0, _inherits2.default)(DraggableTree, _React$Component);
  return (0, _createClass2.default)(DraggableTree, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        items = _this$props.items,
        isDragDisabled = _this$props.isDragDisabled;
      return /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.DragDropContext, {
        onDragEnd: this.onDragEnd
      }, /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Droppable, {
        droppableId: "droppable"
      }, function (provided) {
        return /*#__PURE__*/_react.default.createElement("div", {
          ref: provided.innerRef
        }, items.map(function (item, index) {
          return /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Draggable, {
            isDragDisabled: isDragDisabled,
            key: "draggable-tree-item-".concat(item.path),
            draggableId: "draggable-tree-item-".concat(item.path),
            index: index
          }, function ($provided, $snapshot) {
            return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
              ref: $provided.innerRef
            }, $provided.draggableProps, $provided.dragHandleProps, {
              className: (0, _classnames.default)(styles.draggable, (0, _defineProperty2.default)({}, styles.draggedElement, $snapshot.isDragging)),
              style: $provided.draggableProps.style
            }), /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.SidebarItem, {
              className: styles.sidebarItem,
              to: item.url,
              draggable: !isDragDisabled,
              title: item.title
            }, item.name));
          });
        }), provided.placeholder);
      }));
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(DraggableTree, "propTypes", {
  isDragDisabled: _propTypes.default.bool,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.node.isRequired,
    url: _propTypes.default.string.isRequired,
    title: _propTypes.default.string
  })).isRequired,
  onOrderItems: _propTypes.default.func.isRequired
});
(0, _defineProperty2.default)(DraggableTree, "defaultProps", {
  isDragDisabled: false
});
var _default = exports.default = DraggableTree;
//# sourceMappingURL=DraggableTree.js.map